import React from 'react';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { BreadCrumbItemContainer } from './BreadCrumbItemContainer';
import { PageTypeTitle } from '../../../_lib/components/PageType';
import { BreadcrumbFlyoutProps } from './BreadcrumbFlyout';
import { BreadcrumbNavItem } from '../../../types/api/NavItem';

type BreadCrumbItemProps = {
  hasReadRestrictions: boolean;
  siblings?: BreadcrumbFlyoutProps;
  navItem: BreadcrumbNavItem;
  index: number;
};

export function BreadCrumbItem({ navItem, siblings, index, hasReadRestrictions }: BreadCrumbItemProps) {
  if (navItem.position.includes('first')) {
    if (navItem.position.includes('self')) {
      /**
       * Single Icon with no link.
       * Only visible on the Homepage
       */
      return (
        <>
          {}
          <span className="breadcrumb__listlink font-regular-13-13 breadcrumb__listlink--homepage breadcrumb__listlink--homepage-nolink">
            <SVG svgSpriteId={Icons.HOME_HOUSE} />
          </span>
          {/* this is a "disabled link", this is the proper markup for that */}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            className="breadcrumb__location font-medium-13-13 breadcrumb__location--homepage"
            role="link"
            aria-disabled="true"
            aria-current="page"
          >
            {navItem.link.name}
          </a>
        </>
      );
    }

    /**
     * First item in a breadcrumb list linking to the homepage.
     */
    return (
      <Hyperlink
        tooltipPlacement={TooltipPlacement.TOP}
        hideTooltipFromScreenReader
        to={navItem.link.url}
        className="breadcrumb__listlink font-regular-13-13 breadcrumb__listlink--homepage"
        title={navItem.link.name}
      >
        <span className="invisible">{navItem.link.name}</span>
        <SVG svgSpriteId={Icons.HOME_HOUSE} />
      </Hyperlink>
    );
  }

  if (navItem.position.includes('previous') || navItem.position.length === 0) {
    /**
     * Rendering a breadcrumbitem linking to a parent page.
     * previous = direct parent, navigation needs rel="prev"
     * regular = a page higher in the tree, not direct sibling
     */
    return (
      <BreadCrumbItemContainer
        navItem={navItem}
        siblings={siblings}
        index={index}
        hasReadRestrictions={hasReadRestrictions}
      >
        <Hyperlink
          tooltipPlacement={TooltipPlacement.TOP}
          hideTooltipFromScreenReader
          to={navItem.link.url}
          className="breadcrumb__listlink font-regular-13-13"
          rel={navItem.position.length === 0 ? null : 'prev'}
          title={navItem.link.name !== navItem.title ? navItem.title : null}
        >
          {navItem.link.name}
        </Hyperlink>
      </BreadCrumbItemContainer>
    );
  }

  if (navItem.position.includes('self')) {
    return (
      <BreadCrumbItemContainer
        navItem={navItem}
        siblings={siblings}
        index={index}
        hasReadRestrictions={hasReadRestrictions}
      >
        {/* this is a "disabled link", this is the proper markup for that */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className="breadcrumb__location font-medium-13-13" role="link" aria-disabled="true" aria-current="page">
          {navItem.pageTypeResource ? <PageTypeTitle pageType={navItem.pageTypeResource} /> : navItem.link.name}
        </a>
      </BreadCrumbItemContainer>
    );
  }

  return null;
}
